import React, { Fragment, PureComponent } from 'react'
import ReactHtmlParser from 'react-html-parser'

import cx from 'classnames'
import styles from './index.scss'

class ClampLines extends PureComponent {
  static defaultProps = {
    className: '',
    tag: 'div',
    title: '',
    text: '',
    lines: 2,
    transform: () => false,
  }

  render() {
    const { className, tag, title, text, lines, transform } = this.props
    const CustomTag = `${tag}`
    const classNames = cx('clamplines', className)
    if (!title && !text) return null
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <CustomTag className={classNames}>
          <span className={`clampline clampline-${lines}`}>
            <span className="title">{ReactHtmlParser(title, { transform })}</span>
            <span className="des">{ReactHtmlParser(text, { transform })}</span>
          </span>
        </CustomTag>
      </Fragment>
    )
  }
}

export default ClampLines
